import script from "./FenXiao.vue?vue&type=script&setup=true&lang=js"
export * from "./FenXiao.vue?vue&type=script&setup=true&lang=js"

import "./FenXiao.vue?vue&type=style&index=0&id=928b6ef8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-928b6ef8"]])

export default __exports__